import { Skeleton } from "@/components/ui/skeleton";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Users } from "lucide-react";
import React from "react";
import { WidgetTitle } from "@/components/widgets/WidgetTitle";

interface UserTotalWidgetProps {
  loading?: boolean;
  value?: number | null;
}

const UserTotalWidget: React.FC<UserTotalWidgetProps> = ({ loading, value }) => (
  <div className="w-full min-w-[200px] rounded-lg border flex flex-col bg-white dark:bg-[#0C3451] dark:text-white dark:border-[#0C3451] p-3">
    <div className="flex flex-row items-center justify-between">
      <WidgetTitle className="truncate">Total users</WidgetTitle>
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
            <span className="cursor-pointer">
              <Users className="h-4 w-4 text-primary dark:text-white" />
            </span>
          </TooltipTrigger>
          <TooltipContent side="top">
            <p className="max-w-xs text-xs">Total selected users for reporting, including users assigned to call queues (CQ) and users with direct lines within given time</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
    <div>
      {loading ? (
        <Skeleton className="h-16 w-full" />
      ) : (
        <div className="text-[24px] font-[700] text-primary dark:text-white my-3">
          {value ?? "—"}
        </div>
      )}
    </div>
  </div>
);

export default UserTotalWidget;
